import { theme } from '@noths/polaris-client-ribbons-base';
import { shadowDown } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

const { spacing } = theme;

export const header = css`
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
  padding: ${spacing.xl}px;
  ${shadowDown}
`;

export const title = css`
  ${theme.responsiveText.HEADING.SM}
  margin: 0;
`;

export const closeBtn = css`
  margin-left: auto;
`;
